const BaseService = require('@/services/BaseService')

const namespace = 'seo-report'

const create = (options, cb, errorCb) => {
  BaseService.post(namespace, options, cb, errorCb);
}

export {
  create,
}
